var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriceTag3Line = function SvgPriceTag3Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75716B",
    d: "m9.084 1.75 8.25 1.179 1.178 8.25-7.66 7.66a.833.833 0 0 1-1.179 0l-8.25-8.25a.833.833 0 0 1 0-1.179zm.59 1.768L3.191 10l7.07 7.07 6.482-6.481-.883-6.187zM11.44 8.82a1.666 1.666 0 1 1 2.357-2.357 1.666 1.666 0 0 1-2.357 2.357"
  })));
};
export default SvgPriceTag3Line;